import { Component, OnInit } from '@angular/core';
import { CPhotoGalery } from '../../../models/galery.models/photoGalery.model';
import { PhotoGaleryService } from '../../../services/photoGalery.service';
import { PhotoGaleryGroupService } from '../../../services/photoGaleryGroup.service';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { CCommonPage } from '../../../models/page.models/commonPage.model';
import { CommonPageService } from '../../../services/commonPage.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { CPhotoGalerySearchModel } from 'src/app/models/galery.models/photoGalerySearchModel.model';
import { switchMap } from 'rxjs/operators';
import { CPhotoGaleryGroup } from 'src/app/models/galery.models/photoGaleryGroup.model';


@Component({
    selector: 'galery',
    templateUrl: 'galery.component.html'
})
export class GaleryComponent implements OnInit {
    ngOnInit(): void {
        this.route.paramMap.pipe(
            switchMap((params: ParamMap) => {
                this.galeryGroupId = Number(params.get('id'));

                this.GetPhotoGaleryGroup();

                return this.GetPhotoGaleryArray();
            })).subscribe((data: CPhotoGalery[]) => {
                this.photoGaleryArray = data;
                this.SetDefaultPhoto();
            });
    }

    photoGaleryArray: CPhotoGalery[] = [];
    photoGaleryGroup: CPhotoGaleryGroup = new CPhotoGaleryGroup();
    ApiServiceAddress: string;
    commonPage: CCommonPage = new CCommonPage();
    id: string = 'PhotoGaleriesIndex';
    galeryGroupId: number;
    currentSelectedImage: string = "";
    currentSelectedImageDescription: string = "";

    constructor(private photoGaleryService: PhotoGaleryService, private photoGaleryGroupService: PhotoGaleryGroupService, private commonPageService: CommonPageService, private titleService: Title, private metaService: Meta,
        private route: ActivatedRoute, private router: Router) {
        this.ApiServiceAddress = API_ServerAddress;
        this.galeryGroupId = +this.route.snapshot.paramMap.get('id');
    }

    GetPhotoGaleryArray() {
        let searchModel: CPhotoGalerySearchModel = new CPhotoGalerySearchModel();
        searchModel.fPhotoGaleryGroupId = this.galeryGroupId;

        var photoGalery = this.photoGaleryService.GetList(searchModel);

        return photoGalery;
    }

    SetDefaultPhoto(photoId: number = 0) {
        if (this.photoGaleryArray != null && this.photoGaleryArray.length > 0) {
            var selectedModel = new CPhotoGalery();
            if (photoId == 0) {
                selectedModel = this.photoGaleryArray[0];
            } else {
                selectedModel = this.photoGaleryArray.find(p => p.fId == photoId);
            }
            this.currentSelectedImage = this.ApiServiceAddress + selectedModel.fImageAddressHighQuality;
            this.currentSelectedImageDescription = selectedModel.fDescription;
        }
    }

    GetPhotoGaleryGroup() {
        this.photoGaleryGroupService.GetById(this.galeryGroupId).subscribe((data: CPhotoGaleryGroup) => {
            this.photoGaleryGroup = data;
            this.SetPageMetaData(data);
        });
    }

    SetPageMetaData(model: CPhotoGaleryGroup) {
        this.titleService.setTitle(model.fSubject);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }


}